export default __webpack_public_path__ + "static/media/testimonial-image1.9df88b2a.jpeg";